import {get} from 'lodash';

export default (state = {}, {businessProfile}: any) => {
  return {
    ...state,
    businessProfile: {
      ...get(state, 'businessProfile', {}),
      data: {
        ...get(state, 'businessProfile.data', {}),
        ...businessProfile,
      },
    },
  };
};
